<template>
  <DialogTemplate style="--max-mobile-height: var(--vh-3); max-width: 100vw">
    <div
      class="sfgrranges"
      :class="{ 'no-events': loadingCustomRanges }"
    >
      <div class="sfgrranges_right">
        <div
          v-show="loadingCustomRanges"
          class="sfgrranges_loading anim-fade-in"
        >
          <LoaderSpinner
            :style="`--size:4rem`"
            style="min-height: 3.5rem"
          />
        </div>
        <TabBox
          class="sfgrranges_right"
          tabsStyle="
        --height: 5.5rem;
        --height-inner: 5.75rem;
        --tab-fnt-size: 1rem;
        --tab-radius: 8px;
        --tab-flex: 1;
        --inner-flex: 1;
        --padding-tab: 0.75rem;
        --padding-inner: 0 0 0 0;
      "
          style="
            --z-index-tbbox-content: 4;
            min-width: clamp(1px, 30rem, calc(100vw - 2rem));
            --tbbox-content-clr-back: var(--clr-black-1-3);
            --tabs-inner-overflow-y: hidden;
            --tabs-inner-overflow-x: hidden;
            --tbbox-content-padding: 0.75rem 0 0 0;
          "
          :scrollToActiveTab="false"
          :hasScrollRight="false"
          :options="options"
          idKey="id"
          :tab="tab"
          :hasNamedTabSlot="true"
          @click="item => (tab = item.id)"
        >
          <template
            v-for="player in $store.getters.user_has_flag('SOL_3WAY')
              ? [
                  {
                    id: 'player_oop',
                    swapPlayers: ['player_ip', 'player_oop'],
                    data: player_oop,
                    canApply: oopCanApply,
                  },
                  {
                    id: 'player_ip',
                    swapPlayers: ['player_ip', 'player_oop1'],
                    data: player_ip,
                    canApply: ipCanApply,
                  },
                  { id: 'player_oop1', data: player_oop1, canApply: oop1CanApply },
                ]
              : [
                  {
                    id: 'player_oop',
                    swapPlayers: ['player_ip', 'player_oop'],
                    data: player_oop,
                    canApply: oopCanApply,
                  },
                  { id: 'player_ip', data: player_ip, canApply: ipCanApply },
                ]"
            :key="player.slot"
            #[`tab_${player.id}`]="{ item, value }"
          >
            <div class="position_relative flex-1">
              <SolfigrPlayer
                :hasEditableName="true"
                :item="player.data"
                :groups="player.data.groupRange"
                class="sfgrranges_player"
                :class="[
                  { sfgrranges_player_active: value === item.id },
                  { solfigrplyr_error: !player.canApply },
                ]"
                style="
                  flex: 1;
                  padding: 0;
                  background: transparent;
                  color: currentColor;
                  --clr-rtc-range: var(--clr-tab-range);
                  --table-radius: 4px;
                "
                @update:player="val => updatePlayer(val, player.id)"
              ></SolfigrPlayer>
              <div
                v-if="player.swapPlayers"
                class="mdi mdi-swap-horizontal icon_btn pa-2 text-large clr-grey clr-hover_white csst csst_nm"
                style="
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translate(50%, -50%);
                  z-index: 4;
                "
                @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
                @click="swapRanges(player.swapPlayers)"
              >
                <div
                  class="csst_content text-nowrap"
                  style="position: fixed"
                  v-html="$t('tooltips.swap_ranges')"
                />
              </div>
            </div>
          </template>

          <div class="sfgrranges_range">
            <div
              class="d-flex flex-1"
              style="gap: 0.25rem; z-index: 4"
            >
              <div
                v-if="!mobile"
                :class="{ gw_btn_disabled: !canApply }"
                class="gw_btn flex-1"
                style="--padding: 0; --clr-disabled: var(--clr-grey-2)"
                @click="openSaveRangeDialog"
              >
                <div class="mdi mdi-content-save mr-2"></div>
                {{ $t('btn.save') }}
              </div>
              <!-- we need to reproduce this and pass it to VUE3 core team -->
              <!-- internet is clueless as to why this is happening -->
              <!-- THE BUG - adding this style to the button bellow will lead to bug in production build -->
              <!-- click AA then click SAVE RANGE >> vue results in err trying to apply this style, but el is null -->
              <!-- style="--padding: 0; overflow: none" -->
              <div
                class="gw_btn flex-1 csst"
                @click="copyRangeToClipboard"
              >
                <div class="mdi mdi-tray-arrow-up mr-2"></div>
                {{ $t('btn.export') }}
                <!-- similar or the same issue https://github.com/vuejs/core/issues/5657 -->
                <!-- internet is clueless as to why this is happening -->
                <!-- THE BUG - v-if="rangeCopied" will result to insertBefore vue bug in prod build  -->
                <!-- click AA then copy or try first cliking copy then opening save range dialog -->
                <div
                  v-show="rangeCopied"
                  class="csst_content csst_content_visible"
                  style="
                    transform: translateY(2rem);
                    position: fixed;
                    white-space: normal;
                    word-break: break-word;
                    background: var(--clr-primary);
                    z-index: 1000;
                  "
                  :class="{ csst_content_visible: rangeCopied }"
                  v-html="$t('solfigr.export.range_copied_to_clipboard')"
                />
              </div>
              <div
                class="gw_btn flex-1 csst_nm"
                @click="$store.dispatch('router_set_dialogs', 'import-solfigr-ranges-dialog')"
                @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
              >
                <div class="mdi mdi-tray-arrow-down mr-1"></div>
                {{ $t('btn.import') }}

                <div
                  class="csst_content"
                  style="position: fixed"
                  v-html="$t('tooltips.copy')"
                />
              </div>
            </div>
            <div class="d-flex flex-1">
              <!-- TODO use only one CardGroupesPickerV2  -->
              <CardGroupesPickerV2
                v-show="tab === 'player_oop'"
                class="flex-1"
                :groups="player_oop.groupRange"
                :instaApply="true"
                @update="val => handleUpdate(val, 'player_oop')"
              />
              <CardGroupesPickerV2
                v-show="tab === 'player_ip'"
                class="flex-1"
                :groups="player_ip.groupRange"
                :instaApply="true"
                @update="val => handleUpdate(val, 'player_ip')"
              />
              <CardGroupesPickerV2
                v-show="player_oop1 && tab === 'player_oop1'"
                class="flex-1"
                :groups="player_oop1?.groupRange"
                :instaApply="true"
                @update="val => handleUpdate(val, 'player_oop1')"
              />
            </div>
          </div>
        </TabBox>
      </div>
      <div
        v-if="!mobile"
        class="sfgrranges_left"
      >
        <SavedRangesTableV1
          :namespace="namespace"
          class="flex-1"
          @apply:item="
            item => {
              applyRange(item)
            }
          "
        />
      </div>
    </div>

    <template #dialog_actions>
      <div
        class="f-center mr-auto my-auto"
        style="gap: 0.5rem; min-width: 0"
      >
        <GwSavedRangesMenu
          v-if="mobile"
          :namespace="namespace"
          style="--btn-height: 2.75em"
          @apply:item="val => applyRange(val)"
        >
          <template #opener>
            <div class="gw_btn gw_btn-v1">
              <div class="mdi mdi-folder text-semi-large"></div>
            </div>
          </template>
        </GwSavedRangesMenu>
        <div
          v-if="mobile"
          class="gw_btn gw_btn-v1"
          :class="{ gw_btn_disabled: !canApply }"
          style="--clr-disabled: var(--clr-grey-2)"
          @click="openSaveRangeDialog()"
        >
          <i class="mdi mdi-content-save text-semi-large"></i>
        </div>
        <LinkGuide
          v-if="!$i18n.g1"
          class="truncate"
          :link="links_url_links.how_to_edit_ranges.url"
          :text="links_url_links.how_to_edit_ranges.text"
          @click.stop
        />
      </div>
      <div
        key="close"
        class="gw_btn gw_btn_text gw_btn-v1 mr-2 ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </div>

      <div
        v-if="canApply"
        class="gw_btn-v1 gw_btn_primary"
        data-tst="sfgrranges_confirm"
        @click="apply"
      >
        {{ $t('btn.confirm') }}
      </div>

      <div
        v-if="!canApply"
        class="csst mt-auto"
      >
        <div
          class="gw_btn-v1 gw_btn_disabled no-events"
          style="--clr-disabled: var(--clr-grey-2)"
        >
          {{ $t('btn.confirm') }}
        </div>
        <div
          class="csst_content text-nowrap"
          style="top: -2rem; right: 0"
        >
          {{ $t('solfigr.ranges.chosen_range_above_zero') }}
        </div>
      </div>
    </template>
  </DialogTemplate>
</template>

<script>
import TabBox from '@/components/lib/TabBox'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import CardGroupesPickerV2 from '@/components/CardGroupesPicker/CardGroupesPickerV2'
import LinkGuide from '@/components/AppBar/LinkGuide'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import GwSavedRangesMenu from '@/components/DataTables/v2/GwSavedRangesMenu'
import { rangesDataSkeleton } from '@/helpers/solution'
import { getHandsRangeFromGroupRange, getSolfigrPlayer } from '@/store/solfigr/solfigr_helpers'
import { importRange } from '@/helpers/importFormats'
import SolfigrPlayer from '@/components/ConfigureSolution/SolfigrPlayer'
import SavedRangesTableV1 from '@/components/DataTables/v2/tables/SavedRangesTableV1/SavedRangesTableV1'
import float_mix from '@/mixins/float_mix'
import allCombos from '@/helpers/allCombos.json'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'SolfigrPlayersRangesDialog',
  components: {
    SolfigrPlayer,
    SavedRangesTableV1,
    TabBox,
    DialogTemplate,
    CardGroupesPickerV2,
    LinkGuide,
    LoaderSpinner,
    GwSavedRangesMenu,
  },
  mixins: [float_mix, links_mix],
  props: {
    dialog: Object,
  },
  data() {
    return {
      player_ip: null,
      player_oop: null,
      player_oop1: null,
      tab: 'player_ip',

      rangeCopied: false,
      loadingCustomRanges: false,
    }
  },
  created() {
    this.tab = this.defaultTab
    this.player_oop = {
      position: 'OOP',
      display_position: this.playerOOP.display_position,
      combos: this.playerOOP.combos,
      percentage: this.playerOOP.percentage,
      groupRange: this.playerOOP.groupRange,
    }
    this.player_ip = {
      position: 'IP',
      display_position: this.playerIP.display_position,
      combos: this.playerIP.combos,
      percentage: this.playerIP.percentage,
      groupRange: this.playerIP.groupRange,
    }
    if (this.$store.getters.user_has_flag('SOL_3WAY')) {
      this.player_oop1 = {
        position: 'OOP+1',
        display_position: this.playerOOP1.display_position,
        combos: this.playerOOP1.combos,
        percentage: this.playerOOP1.percentage,
        groupRange: this.playerOOP1.groupRange,
      }
    }
  },
  methods: {
    async applyRange(item) {
      this.loadingCustomRanges = true
      const result = await this.$store.dispatch('api_call', {
        apiVersion: 'v1',
        endpoint: `poker/custom-solutions/custom-trees/saved-ranges/${item.id}/`,
        mutation: 'api_poker_custom_range',
        hasCancel: false,
        message: {
          type: 'error',
        },
      })
      this.loadingCustomRanges = false
      const range = result?.response?.data?.range
      if (range) {
        const { tableGroups } = rangesDataSkeleton()
        const api_player = {
          position: this[`${this.tab}`].name,
          range,
        }
        const res = getSolfigrPlayer({ tableGroups, api_player })
        this.handleUpdate(res, this.tab)
      }
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-players-ranges-dialog')
    },
    apply() {
      this.$store.dispatch(`${this.namespace}/slfrm_updatePlayers`, {
        playerIP: this.player_ip || this.playerIP,
        playerOOP: this.player_oop || this.playerOOP,
        playerOOP1: this.player_oop1 || this.playerOOP1,
      })
      this.close()
    },
    swapRanges(swapPlayers) {
      const player1 = this[swapPlayers[0]]
      const player2 = this[swapPlayers[1]]

      this[swapPlayers[0]] = {
        ...player1,
        combos: player2.combos,
        percentage: player2.percentage,
        groupRange: player2.groupRange,
      }
      this[swapPlayers[1]] = {
        ...player2,
        combos: player1.combos,
        percentage: player1.percentage,
        groupRange: player1.groupRange,
      }
    },
    updatePlayer(val, player) {
      this[`${player}`] = val
      if (player === 'player_ip') {
        if (this.player_oop.display_position === this[`${player}`].display_position) {
          this.player_oop.display_position = this.player_oop.position
        }
      } else if (player === 'player_oop') {
        if (this.player_ip.display_position === this[`${player}`].display_position) {
          this.player_ip.display_position = this.player_ip.position
        }
      } else if (player === 'player_oop1') {
        if (this.player_oop1.display_position === this[`${player}`].display_position) {
          this.player_oop1.display_position = this.player_oop1.position
        }
      }
    },
    handleUpdate(val, player) {
      val = JSON.parse(JSON.stringify(val))
      this[`${player}`] = {
        ...this[`${player}`],
        combos: val.combos,
        percentage: val.percentage,
        groupRange: val.groups || val.groupRange,
      }
    },

    emptyImportInput() {
      this.importedStr = ''
      this.importError.active = false
      if (this.$refs.importInputRange) {
        this.$refs.importInputRange.focus()
      }
    },
    handleImportInput(str) {
      let res = importRange(str)
      res = res.tableGroups
      if (res.error) {
        console.log('ERORR')
        return
      }

      const groups = this[`${this.tab}`].groupRange
      res = res.sort(
        (a, b) => groups.findIndex(i => i.id === a.id) - groups.findIndex(i => i.id === b.id),
      )

      const combos = res.reduce((acc, group) => acc + group.hand_count * group.range, 0)
      const player = {
        ...this[`${this.tab}`],
        groupRange: res,
        combos,
        percentage: combos / 1326,
      }
      this.handleUpdate(player, this.tab)
    },

    copyRangeToClipboard(rangeCopied = true) {
      const { groupRange } = this[this.tab]

      const hands = groupRange.reduce((acc, i) => {
        i.hands.forEach(h => {
          acc[h] =
            typeof i.range === 'number' && i.range % 1 !== 0
              ? Math.round(i.range * 1e12) / 1e12 // Round to 12 decimal places only if necessary
              : i.range
        })
        return acc
      }, {})

      const str = allCombos.map(cc => `${cc}: ${hands[cc] || 0}`).join(',')
      this.rangeCopied = rangeCopied
      navigator.clipboard.writeText(str)
      setTimeout(() => {
        this.rangeCopied = false
      }, 1000)
    },
    openSaveRangeDialog() {
      const range = getHandsRangeFromGroupRange({ groupRange: this[this.tab].groupRange })
      const newRange = {
        id: '',
        name: '',
        tags: [],
        range,
      }
      this.$store.commit(`${this.namespace}/slfrm_set`, {
        key: 'slfrm_selectedRange',
        value: newRange,
      })
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-save-range-dialog_namespace-${this.namespace}`,
      )
    },
    handleKeyPress(keys) {
      // passed down from app-dialogs
      if ((keys?.includes('control') || keys?.includes('command')) && keys?.includes('v')) {
        navigator.clipboard
          .readText()
          .then(text => {
            this.handleImportInput(text)
          })
          .catch(err => {})
        return
      }
      if ((keys?.includes('control') || keys?.includes('command')) && keys?.includes('c')) {
        this.copyRangeToClipboard(true)
      }
    },
  },
  computed: {
    ipCanApply() {
      return this.player_ip.percentage > 0
    },
    oopCanApply() {
      return this.player_oop.percentage > 0
    },
    oop1CanApply() {
      return this.player_oop1?.percentage > 0
    },
    canApply() {
      return (
        this.ipCanApply &&
        this.oopCanApply &&
        (this.$store.getters.user_has_flag('SOL_3WAY') ? this.oop1CanApply : true)
      )
    },
    namespace() {
      return this.dialog.namespace || null
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },

    // TODO: would be nice to have one getter for all players
    playerIP() {
      return this.$store.getters[`${this.namespace}/slfrm_playerIP`]
    },
    playerOOP() {
      return this.$store.getters[`${this.namespace}/slfrm_playerOOP`]
    },
    playerOOP1() {
      return this.$store.getters[`${this.namespace}/slfrm_playerOOP1`]
    },

    defaultTab() {
      const dict = { IP: 'player_ip', OOP: 'player_oop', 'OOP+1': 'player_oop1' }
      return dict[this.dialog.player] || 'player_ip'
    },
    options() {
      const res = [
        {
          id: 'player_oop',
          title: this.$t('players.OOP'),
        },
        {
          id: 'player_ip',
          title: this.$t('common.IP'),
        },
        this.$store.getters.user_has_flag('SOL_3WAY') && {
          id: 'player_oop1',
          title: this.$t('players.OOP1'),
        },
      ].filter(Boolean)
      return res
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
  },
  watch: {
    globals_action(val) {
      if (val.includes('solfigrrangesimport_')) {
        const str = val.replace('solfigrrangesimport_', '')
        this.handleImportInput(str)
        this.$store.dispatch('globals_action', ``)
      }
    },
  },
}
</script>

<style lang="scss">
.sfgrranges {
  position: relative;
  display: flex;
  justify-content: center;
  min-height: 0;
  min-width: 0;
  gap: 1rem;
  max-height: 42.325rem;
  overflow: auto;
  &_left {
    display: flex;
    height: 100%;
    flex: 1;
    border-radius: 4px;
    min-width: clamp(1px, 29rem, 100vw);
  }
  &_right {
    flex: 1;
    display: flex;
    position: relative;
    border-radius: 4px;
  }
  &_player {
    --clr-tab-range: var(--clr-black-4);
    &_active {
      --clr-tab-range: var(--clr-range);
    }
    &:hover {
      --clr-tab-range: var(--clr-range) !important;
    }
  }
  &_loading {
    z-index: 4;
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }
  &_range {
    padding: 0 0.75rem 0.75rem 0.75rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    z-index: 4;
    flex: 1;
    position: relative;
  }
}

@media (max-width: 1023px) {
  .sfgrranges {
    max-height: unset;
    &_right {
      margin-top: 0;
    }
  }
}
</style>
